module.exports = __webpack_public_path__ + "static/img/multi-device-main.de748ed3.png";